import { heroStats } from "@/mocks/home";

const HERO_IMG =
  "https://readdy.ai/api/search-image?query=Tall%20portrait%20editorial%20illustration%20poster%20for%20an%20internet%20hot%20event%20timeline%20tracker%2C%20a%20large%20magnifying%20glass%20examining%20a%20winding%20chronological%20ribbon%20with%20small%20clock%20and%20flame%20hotness%20markers%2C%20floating%20camera%20loudspeaker%20and%20chat%20bubble%20icons%20scattered%20around%2C%20layers%20of%20warm%20coral%20red%20and%20terracotta%20over%20a%20plain%20warm%20cream%20paper%20background%2C%20bold%20modern%20flat%20vector%20art%20with%20clean%20minimal%20composition%20and%20generous%20negative%20space%2C%20high%20detail%2C%20soft%20even%20lighting&width=900&height=1125&seq=hero-cover-69&orientation=portrait";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 pb-12 pt-28 md:px-6 md:pt-40 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:pb-16">
        {/* left copy */}
        <div className="flex flex-col justify-center">
          <div className="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            今日热榜已更新 · 09:00
          </div>

          <h1 className="font-heading text-4xl leading-tight text-foreground-950 md:text-5xl lg:text-[54px]">
            吃瓜不只看热闹，
            <br />
            更要看<span className="text-primary-600">前因后果</span>与始末。
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            「69吃瓜」把热门瓜事按时间拆成可回溯的脉络节点——一张脉络图、一段完整时间线，
            从起因到结局逐步清点，经过不漏、口径并列，事件始末一次看明白。
          </p>

          {/* search pill */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              window.location.hash = "#grid";
            }}
            className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
          >
            <div className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400" />
              <input
                type="text"
                name="q"
                placeholder="搜事件 / 关键词 / 人物昵称…"
                className="h-12 w-full rounded-lg border border-background-300 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-950 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              />
            </div>
            <button
              type="submit"
              className="h-12 rounded-lg bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
            >
              开始梳理
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-file-shield-2-line text-primary-500" /> 每节点标注首发信源
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-archive-line text-primary-500" /> 36 个专题持续追更
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line text-primary-500" /> 30 天自动复核
            </span>
          </div>
        </div>

        {/* right visual — 封面驱动 */}
        <div className="relative flex items-center justify-center">
          <div className="relative w-full max-w-sm lg:max-w-md">
            <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl bg-primary-100" />
            <div className="relative overflow-hidden rounded-2xl border border-background-200">
              <img
                src={HERO_IMG}
                alt="69吃瓜 事件脉络与时间线梳理"
                className="aspect-[4/5] w-full object-cover object-top"
              />
            </div>

            {/* floating hot badge */}
            <div className="absolute -left-5 top-10 rounded-xl bg-foreground-950 px-4 py-3 text-background-50 shadow-soft">
              <p className="flex items-center gap-1.5 text-xs font-semibold">
                <i className="ri-fire-fill text-accent-400" /> 本期爆点
              </p>
              <p className="mt-1 text-[11px] text-background-300">连麦剧本被扒</p>
            </div>
            {/* floating stat card */}
            <div className="absolute -right-4 bottom-8 flex items-center gap-3 rounded-xl bg-accent-500 px-4 py-3 text-background-50 shadow-soft">
              <i className="ri-line-chart-fill text-xl" />
              <div>
                <p className="text-lg font-bold leading-none">982.4w</p>
                <p className="mt-1 text-[11px] text-background-100/90">24h 热度 · 全网第 1</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* stats strip */}
      <div className="mx-auto max-w-6xl px-4 md:px-6 pb-10">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div key={s.label} className="bg-background-50 px-5 py-4">
              <p className="font-heading text-2xl text-primary-600 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}